import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var leaders = new Swiper(".section2 .mySwiper", {
    slidesPerView: 5,
    navigation: {
        nextEl: ".section2 .swiper-button-next",
        prevEl: ".section2 .swiper-button-prev",
    },
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
	},
	speed:800,
    grid: {
        rows: 2,
        fill: 'column'
    },
  spaceBetween: 0,
  breakpoints: {
    // 屏幕宽度小于 600px 时，展示 1 列
    320: {
      slidesPerView: 2,
      grid: {
        rows: 1,
        fill: 'row'
      },
    },
    // 屏幕宽度小于 1024px 时，展示 2 列
    1024: {
      slidesPerView: 4,
      grid: {
        rows: 2,
        fill: 'row'
      },
    },
    // 屏幕宽度大于 1024px 时，展示 5 列
    1025: {
      slidesPerView: 5,
      grid: {
        rows: 2,
        fill: 'row'
      },
    },
  },
});


$(document).ready(function() {
  // 获取所有的 li
  var allItems = $('#itemList li');
  // 总数量
  var totalCount = allItems.length;
  // 当前显示到第几个
  var currentIndex = 0;
  // 每次加载的数量
  var step = 3;
  // 默认显示的数量
  var defaultShow = 6;
  
  // 初始化：先显示前6个
  function initDisplay() {
    // 先隐藏所有
    allItems.hide();
    // 显示前6个
    allItems.slice(0, defaultShow).show();
    currentIndex = defaultShow;
    
    // 如果总数量小于等于默认显示数量，直接隐藏按钮
    if (totalCount <= defaultShow) {
      $('#loadMoreBtn').hide();
    }
  }
  
  // 调用初始化
  initDisplay();
  
  // 点击加载更多按钮
  $('#loadMoreBtn').on('click', function() {
    // 计算这次要显示到第几个
    var nextIndex = Math.min(currentIndex + step, totalCount);
    
    // 显示从 currentIndex 到 nextIndex 的 li
    allItems.slice(currentIndex, nextIndex).fadeIn();
    
    // 更新当前索引
    currentIndex = nextIndex;
    
    // 如果已经全部显示，隐藏按钮
    if (currentIndex >= totalCount) {
      $(this).hide();
    }
  });
});
